<template>
  <div>
    <div class="air__utils__heading">
      <h5>Book Issue/Return</h5>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center">
          <div class="col-8 mb-2"  v-if="!selectedRowKeys.length">
            <div class="row align-items-center">
              <!-- Book Issue Search -->
              <div class="col-md-4 col-12 mb-2" v-if="!selectedRowKeys.length">
                <div class="text-right">
                  <a-input-search
                    placeholder="Search Issue..."
                    size="large"
                    v-model="search"
                    @search="searchOrder"
                  />
                </div>
              </div>
              <!-- Student Search -->
              <div class="col-md-4 col-12 mb-2" v-if="!selectedRowKeys.length">
                <div class="text-right">
                  <a-input-search
                    placeholder="Search Student..."
                    size="large"
                    v-model="student_search"
                    @search="searchStudent"
                  />
                </div>
              </div>
              <!-- Book Search -->
              <div class="col-md-4 col-12 mb-2" v-if="!selectedRowKeys.length">
                <div class="text-right">
                  <a-input-search
                    placeholder="Search Book..."
                    size="large"
                    v-model="book_search"
                    @search="searchBook"
                  />
                </div>
              </div>
            </div>
<!--            <div class="row align-items-center">
              <div class="col-md-3 col-12 mb-2">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Classes"
                  optionFilterProp="children"
                  v-model="selectedClassId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleClassSelect"
                >
                  <a-select-option :value="undefined"
                  >All Classes</a-select-option
                  >
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                      {{schoolClass.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>
              <div class="col-md-3 col-12 mb-2">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Categories"
                  optionFilterProp="children"
                  v-model="selectedCategoryId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleCategorySelect"
                >
                  <a-select-option :value="undefined">
                    All Categories
                  </a-select-option>
                  <template v-for="category in categories">
                    <a-select-option :value="category.id" :key="category.id">
                      {{category.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>
              <div class="col-md-3 col-12 mb-2">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Sub Categories"
                  optionFilterProp="children"
                  v-model="selectedSubCategoryId"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleSubCategorySelect"
                >
                  <a-select-option :value="undefined">
                    All Sub Categories
                  </a-select-option>
                  <template v-for="subCategory in subCategories">
                    <a-select-option :value="subCategory.id" :key="subCategory.id">
                      {{subCategory.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </div>
            </div>-->
          </div>

          <div class="col-4 text-right mb-2" v-if="pagepermission.insertable">
<!--            <div class="d-inline-flex mr-2">
              <bulk-upload-product />
            </div>-->
            <!-- <div class="d-inline-flex mr-2">
              <return-book @created="handleCreated"/>
            </div> -->
            <div class="d-inline-flex mr-2 mb-2">
              <issue-book @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <loans-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// import ProductsTable from '@/components/inventory/master/product/index'
// import NewProduct from '@/components/inventory/master/product/new'
// import BulkUploadProduct from '@/components/inventory/master/product/Bulk'
// import { debounce } from 'lodash'
import LoansTable from '@/components/library/loan/index'
import IssueBook from '@/components/library/loan/issuebook'
// import ReturnBook from '@/components/library/loan/returnbook'

export default {
  components: {
    // ProductsTable,
    // NewProduct,
    // BulkUploadProduct,
    LoansTable,
    IssueBook,
    // ReturnBook,
  },
  beforeMount: function() {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('library', 22)
    rc.then(data => {
      // console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  created() {
    // this.searchProduct = debounce(this.searchProduct, 500)
  },
  mounted: function() {
    this.getOrders()
    /* this.getClasses()
    this.getProductCategories() */
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      search: null,
      student_search: null,
      book_search: null,
      selectedRowKeys: [],
      filters: [],
      /* schoolClasses: [],
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      selectedClassId: undefined,
      selectedCategoryId: undefined,
      selectedSubCategoryId: undefined, */
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    /* getClasses: function() {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getProductCategories: function() {
      this.$http.get('/api/inventory/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_category_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function(selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_category_id === selectedCategoryId)
    }, */
    getOrders: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      // this.$http.get('/api/inventory/order/all', {
      this.$http.get('/api/library/book/loans', {
        params: {
          /* class_id: this.selectedClassId,
          category_id: this.selectedCategoryId,
          sub_category_id: this.selectedSubCategoryId, */
          limit: this.pageSize,
          page: page,
          search: this.search,
          student_search: this.student_search,
          book_search: this.book_search,
          ...this.filters,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchOrder: function(value) {
      this.search = value
      this.getOrders(true)
    },
    searchStudent: function(value) {
      this.student_search = value
      this.getOrders(true)
    },
    searchBook: function(value) {
      this.book_search = value
      this.getOrders(true)
    },
    onChangeSearchProducts: function(e) {
      this.search = e.target.value
      this.getOrders(true)
    },
    handleCreated: function() {
      this.getOrders()
    },
    handleUpdateTable: function(args) {
      console.log('args', args)
      if (args !== undefined && args !== null && args.length > 0) {
        this.sorterField = args[0]
        this.sorterOrder = args[1]
        this.filters = args[2]
      }
      this.getOrders()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getOrders()
    },
    onChange(current) {
      this.current = current
      this.getOrders()
    },
    /* handleClassSelect(selectedClassId) {
      this.getProducts(true)
    },
    handleCategorySelect(selectedCategoryId) {
      this.getProducts(true)
      this.getSubCategories(selectedCategoryId)
    },
    handleSubCategorySelect(selectedSubCategoryId) {
      this.getProducts(true)
    }, */
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
